// Distinct T1D stage values from the policy-reviewed field catalogue. No
// fallback list is kept in the browser: a metadata failure is visible rather
// than silently offering values the server may now reject.
import { useFields } from "./useFields";

// Mónica's clinical criteria — used verbatim as tooltip text per
// PROFILING_SF_BUNDLE.md §11.3.
export const T1D_STAGE_HELP: Record<string, string> = {
  "Stage 1":
    "≥2 IAb+, normal glucose, asymptomatic. Pre-clinical T1D.",
  "Stage 2":
    "≥2 IAb+, abnormal glucose (dysglycemia), asymptomatic. Pre-clinical T1D.",
  "Stage 3": "Clinical T1D diagnosis per ADA criteria. Symptomatic.",
  "Stage 4": "Established T1D.",
};

type T1dStageField = "contact.T1D_Stage__c" | "child.T1D_Stage__c";

export function useT1dStages(fieldKey?: T1dStageField) {
  const catalogue = useFields();
  const values = Array.from(new Set(
    catalogue.fields
      .filter((field) => fieldKey
        ? field.key === fieldKey
        : field.key === "contact.T1D_Stage__c" || field.key === "child.T1D_Stage__c")
      .filter((field) => field.available && field.capabilities.includes("filter"))
      .flatMap((field) => [...(field.options ?? [])]),
  ));
  return {
    values,
    isLoading: catalogue.isLoading,
    error: catalogue.error,
  };
}
